import { Directive, ContentChildren, QueryList, Input, NgZone } from '@angular/core';
import { BindingData, BindingList } from '@farris/devkit';
import { ColumnComponent } from '@progress/kendo-angular-grid';

@Directive({
  selector: '[aggregate]',
})
export class GridColumnAggregateDirective {

  @Input() aggregate: string | boolean;

  public get field(): string {
    return this.column.field;
  }

  private get aggrType(): string {
    let type = 'none';
    if (typeof (this.aggregate) === 'boolean') {
      // é»è®¤ä¸ºsumï¼å¦æä½¿ç¨æä»¤æ¶ä¼ å¥çinputä¸ºå¸å°ç±»åï¼ä½¿ç¨sumã
      if (this.aggregate) {
        type = 'sum';
      }
    } else if (typeof (this.aggregate) === 'string') {
      type = this.aggregate;
    }
    return type;
  }

  constructor(private column: ColumnComponent, private ngZone: NgZone) {
  }

  public recalculateSummary(bindingList: BindingList) {
    let summary = null;
    if (this.aggrType === 'sum') {
      const plainData = bindingList.toJSON().map(item => {
        // èèå¸®å©åudtçæåµï¼fieldæ¯a.bçæ ¼å¼ã
        return this.field.split('.').reduce((prevPath, currPath) => {
          return prevPath[currPath];
        }, item);
      });
      if (plainData && plainData.length) {
        summary = plainData.reduce((prev, curr) => {
          return prev + curr;
        });
      }
    } else if (this.aggrType === 'count') {
      // è®¡æ°ï¼å¦æå¯ç¨åé¡µï¼åªè®¡ç®å½åé¡µï¼å æ­¤ä½¿ç¨lengthèétotalã
      summary = bindingList.length;
    }
    this.updateFooter(summary);
  }

  public updateFooter(content: any) {
    if (this.aggregate) {
        // å­å¨æ§è½é®é¢ï¼å»æsetTimeoutã
        // åè¡¨çåè¶å¤ï¼æ­¤å¤é®é¢è¶ä¸¥éï¼éè¦æ­£åè§£å³ä»¥ä¸éè¯¯ã
        // todo: settimeoutæ¯ä¸ºäºè§£å³æ°æ®ååæ¶angularæ¥éï¼å¦ææ´æ°é¡µèçé»è¾ä¸å¨gridbindingåèµ·ï¼æ¯å¦è¿å­å¨é®é¢ï¼
        // setTimeout(() => {
          this.column['summary'] = content;
        // });
    }
  }
}


@Directive({
  selector: '[farrisSummary]'
})
export class GridSummaryDirective/* implements OnInit, AfterViewInit*/ {
  @Input('farrisSummary') summary: string;
  constructor(private bindingData: BindingData) { }

}
